import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const TogReceived = lazy(() => import('./pages/TogReceived'));
const TogView = lazy(() => import('./pages/TogView'));

const togRoutes: RouteObject[] = [
  {
    index: true,
    element: <TogReceived />,
  },
  {
    path: ':id',
    element: <TogView />,
  },
];

export default togRoutes;
